import { Container } from 'pixi.js';
import { EVENTS } from '../lib/constants';
import { GameConfigs } from '../lib/globals/GameConfigs';

class Lines extends Container {
	config = null;
	linesHandler = null;
	reels = null;
	currentItems = [];
	lastLineEventsended = false;
	stickyWilds = null;

	constructor(cfg, _linesHandler, _reels) {
		super();
		this.config = cfg;
		this.reels = _reels;
		this.linesHandler = _linesHandler;
		this.bonusInit = false;
		this.animationTime = this.config.animationTime;

		window.addEventListener(EVENTS.SETTINGS_UPDATE, this, false);
		window.addEventListener(
			EVENTS.BONUS_ROUND_STATE,
			this.bonusRound.bind(this),
			false
		);
		window.addEventListener(
			EVENTS.SERVER_MSG,
			this.serverMSG.bind(this),
			false
		);
	}

	handleEvent(evt) {
		if (evt.type === EVENTS.SETTINGS_UPDATE) {
			if (evt.detail.data.game_animation !== undefined) {
				evt.detail.data.game_animation
					? (this.animationTime = 1500)
					: (this.animationTime = 750);
			}
		}
	}
	bonusRound(e) {
		if (e.detail.state === 'init') {
			this.bonusInit = true;
		}
	}
	serverMSG(e) {
		if (e.detail.service === 'bonusstep') {
			this.bonusInit = false;
		}
	}
	animate(_winLines) {
		this.lastLineEventsended = false;
		this.winLines = _winLines;
		this.currentLineIndex = -1;
		if (this.winLines.length === 0) {
			if (!this.lastLineEventsended) {
				this.linesHandler({ type: EVENTS.ALL_LINES_FINISHED });
				this.linesHandler({ type: EVENTS.MAIN_LINE_FINISHED });
				this.lastLineEventsended = true;
			}
			return;
		}

		if (this.winLines.length === 1) {
			this.linesHandler({ type: EVENTS.MAIN_LINE_FINISHED });
			this.animateNextLine();
		} else {
			if (this.winLines.length > 0) {
				this.highlightAllLines();
			}
		}

		// this.animateNextLine();
	}

	highlightAllLines() {
		if (!this.lastLineEventsended) {
			// ('animate line')
			if (GameConfigs.modal === 'win') {
				window.sm.stop('mini_win_sfx', 0);
			} else {
				window.sm.play({ name: 'mini_win_sfx' });
			}
		}
		for (let i = 0; i < this.reels.length; i++) {
			const reel = this.reels[i];
			const items = reel.items;

			for (let k = 0; k < items.length; k++) {
				const item = items[k]; //items.length - k - 1
				item.disable();
			}
		}

		for (let index = 0; index < this.winLines.length; index++) {
			var winLine = this.winLines[index];
			var line = this.config.lines[winLine.line];

			if (winLine.line !== -1) {
				this.currentItems = [];
				for (let i = 0; i < this.reels.length; i++) {
					const reel = this.reels[i];
					const items = reel.items;

					for (let k = 0; k < items.length; k++) {
						const item = items[k]; //items.length - k - 1
						if (k === line[i]) {
							if (i < winLine.itemcount) {
								item.enable();
								item.animate();
							} else {
								//item.enable();
							}
						}
						this.currentItems.push(item);
					}
				}
			} else {
				for (let i = 0; i < this.reels.length; i++) {
					const reel = this.reels[i];
					const items = reel.items;
					for (let k = 0; k < items.length; k++) {
						const item = items[k]; //items.length - k - 1 itemid
						if (item.item.id === winLine.itemid) {
							item.enable();
							item.animate();
							this.currentItems.push(item);
						}
					}
				}
			}
		}

		if (this.currentItems.length > 0) {
			let playedSnds = {};
			for (let s = 0; s < this.currentItems.length; s++) {
				let item = this.currentItems[s];
				if (item.item.animation.fg.sound) {
					if (!playedSnds[item.item.animation.fg.sound]) {
						playedSnds[item.item.animation.fg.sound] = true;
						window.sm.play({ name: item.item.animation.fg.sound });
					}
				}
			}
		}

		this.timeoutLine = setTimeout(() => {
			for (let i = 0; i < this.currentItems.length; i++) {
				const item = this.currentItems[i];
				item.disable();
			}
			this.linesHandler({ type: EVENTS.MAIN_LINE_FINISHED });
			this.animateNextLine();
		}, 2000);
		// this.animateNextLine();
	}

	animateNextLine() {
		if (this.bonusInit === true) {
			return;
		}
		this.currentLineIndex++;
		if (this.currentLineIndex >= this.winLines.length) {
			this.currentLineIndex = 0;
			//fire lines all finished
			if (!this.lastLineEventsended) {
				// this.linesHandler({ type: EVENTS.MAIN_LINE_FINISHED });
				this.linesHandler({ type: EVENTS.ALL_LINES_FINISHED });
				this.lastLineEventsended = true;
			}
		}

		this.animateLine(this.currentLineIndex);

		this.timeoutIndex = setTimeout(() => {
			this.animateNextLine();
		}, this.animationTime);
	}

	animateLine(index) {
		if (this.bonusInit === true) {
			return;
		}

		var winLine = this.winLines[index];
		if (winLine !== undefined) {
			var line = this.config.lines[winLine.line];
			for (let i = 0; i < this.currentItems.length; i++) {
				const item = this.currentItems[i];
				item.disable();
			}
			if (winLine.line !== -1) {
				this.currentItems = [];
				this.linesHandler({ type: EVENTS.LINE_STARTED, line: winLine });
				for (let i = 0; i < this.reels.length; i++) {
					const reel = this.reels[i];
					const items = reel.items;

					for (let k = 0; k < items.length; k++) {
						const item = items[k]; //items.length - k - 1
						if (k === line[i]) {
							item.enable();
							if (i < winLine.itemcount) {
								item.animate();
								if (item.item.type === 'minor') {
									// console.log('SCALE THIS MINOR');
								}
								if (!this.lastLineEventsended) {
									if (item.item.animation.fg.sound) {
										if (GameConfigs.modal === 'win') {
											window.sm.stop(item.item.animation.fg.sound, 0);
										} else {
											window.sm.play({ name: item.item.animation.fg.sound });
										}
									}
								}
							} else {
								item.disable();
							}
						} else {
							item.disable();
						}

						this.currentItems.push(item);
					}
				}
			} else {
				this.linesHandler({ type: EVENTS.LINE_STARTED, line: winLine });
				for (let i = 0; i < this.reels.length; i++) {
					const reel = this.reels[i];
					const items = reel.items;
					for (let k = 0; k < items.length; k++) {
						const item = items[k]; //items.length - k - 1 itemid
						if (item.item.id === winLine.itemid) {
							item.enable();
							item.animate();
							// window.sm.play({ name: "bell_sound_sfx" });
							this.currentItems.push(item);
						} else {
							item.disable();
						}
					}
				}
			}
		}
	}
	fastStop() {
		this.reset();
		this.linesHandler({ type: EVENTS.ALL_LINES_FINISHED });
		this.lastLineEventsended = true;
	}

	reset() {
		clearTimeout(this.timeoutIndex);
		clearTimeout(this.timeoutLine);
		for (let i = 0; i < this.currentItems.length; i++) {
			const item = this.currentItems[i];
			item.stopLoop();
		}
	}
}

export default Lines;
